module.exports = __webpack_public_path__ + "img/boy_010025.351ed485.png";